import React, { createContext, useContext, useState } from 'react';

import SignUpModal from '../../components/SignUpModal';

// eslint-disable-next-line no-console
const warn = () =>
  console.warn('The SignUpModal requires a Context Provider in the tree.');

const SignUpModalContext = createContext([warn, warn]);

const Provider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  const open = url => {
    setImageUrl(url);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setImageUrl(null);
  };

  return (
    <SignUpModalContext.Provider value={[open, close]}>
      {children}
      <SignUpModal
        open={isOpen && imageUrl}
        imgUrl={imageUrl}
        onCloseRequested={close}
      />
    </SignUpModalContext.Provider>
  );
};

export const useSignUpModal = () => useContext(SignUpModalContext);

export default Provider;
